(function (namespace, $) {
	"use strict";

	var AppChart = function () {
		var o = this;
		$(document).ready(function () {
			o.initialize();
		});
	};

	var p = AppChart.prototype;

	p.initialize = function () {
		Highcharts.setOptions({			
			lang: {
				resetZoom: Lang.get("chart.reset_zoom"),
				downloadCSV: Lang.get("chart.download_csv"),
				downloadJPEG: Lang.get("chart.download_jpeg"),
				downloadPDF: Lang.get("chart.download_pdf"),
				downloadPNG: Lang.get("chart.download_png"),
				downloadSVG: Lang.get("chart.download_svg"),
				downloadXLS: Lang.get("chart.download_xls"),
				exitFullscreen: Lang.get("chart.exit_fullscreen"),
				loading: Lang.get("chart.loading"),
				noData: Lang.get("chart.no_data"),
				printChart: Lang.get("chart.print_chart"),
				hideData: Lang.get("chart.hide_data"),
				viewData: Lang.get("chart.view_data"),
				viewFullscreen: Lang.get("chart.view_fullscreen"),
				contextButtonTitle: Lang.get("chart.context_button_title"),
				drillUpText: Lang.get("chart.drill_up_text"),
			},
			xAxis: {
				labels: {
					style: {
						fontSize: '11px'
					}
				},				
				title: {
					style: {
						fontSize: '12px',
					},
				},
			},
			yAxis: {
				labels: {
					style: {
						fontSize: '11px',
					}
				},
				title: {
					style: {
						fontSize: '12px',
					},
				},
			},
			legend: {
				itemStyle: {
					fontSize: "12px",
				}
			},
		});
	};

	p._addChartStackedColumn = function (
		id,
		title,
		categories,
		series,
		newOptions,
	) {
		var options = {
			chart: {
				type: "column",
				zoomType: "x",
			},
			title: {
				text: title,
			},
			xAxis: {
				categories: categories,
				title: {
					text: null,
				},
			},
			yAxis: {
				min: 0,
				labels: {
					overflow: "justify",
				},
			},
			tooltip: {
				valueSuffix: Lang.get("form.hours"),
			},
			plotOptions: {
				column: {
					stacking: "normal",
					dataLabels: {
						enabled: true,
						color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || "white",
						style: {
							textShadow: "0 0 3px black",
						},
					},
				},
			},
			credits: {
				enabled: false,
			},
			series: series,
		};

		if (newOptions) {
			window.gpssat.App._setValueObject(options, newOptions);
		}

		jQuery("#" + id).highcharts(options);
	};

	p._addChartPie = function (id, title, series, newOptions) {
		var options = {
			chart: {
				plotBackgroundColor: null,
				plotBorderWidth: null,
				plotShadow: false,
				type: "pie",
			},
			title: {
				text: title,
			},
			tooltip: {
				pointFormat:
					"{series.name}: <b>{point.y:.2f} - {point.percentage:.2f}%</b>",
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: "pointer",
					dataLabels: {
						enabled: false,
						formatter: function () {
							return this.percentage.toFixed(2) + "%";
						},
					},
					showInLegend: true,
				},
			},
			legend: {
				enabled: true,
				layout: "vertical",
				labelFormatter: function () {
					return (
						"<div>" +
						this.name +
						" (" +
						this.y.toFixed(2) +
						"/" +
						this.percentage.toFixed(2) +
						"%)</div>"
					);
				},
			},
			credits: {
				enabled: false,
			},
			series: series,
		};

		if (newOptions) {
			window.gpssat.App._setValueObject(options, newOptions);
		}

		jQuery("#" + id).highcharts(options);
	};

	p._addChartDualAxesLineColumn = function (
		id,
		title,
		categories,
		series,
		newOptions,
	) {
		var options = {
			chart: {
				zoomType: "x",
			},
			title: {
				text: title,
			},
			xAxis: [
				{
					categories: categories,
					crosshair: true,
				},
			],
			yAxis: [
				{
					labels: {
						format: "{value}",
						style: {
							color: Highcharts.getOptions().colors[1],
						},
					},
					title: {
						text: series[1].name,
						style: {
							color: Highcharts.getOptions().colors[1],
						},
					},
				},
				{
					title: {
						text: series[0].name,
						style: {
							color: Highcharts.getOptions().colors[0],
						},
					},
					labels: {
						format: "{value}",
						style: {
							color: Highcharts.getOptions().colors[0],
						},
					},
					opposite: true,
				},
			],
			tooltip: {
				shared: true,
			},
			credits: {
				enabled: false,
			},
			series: series,
		};

		if (newOptions) {
			window.gpssat.App._setValueObject(options, newOptions);
		}

		jQuery("#" + id).highcharts(options);
	};

	window.gpssat.AppChart = new AppChart();
})(window.gpssat, jQuery);
